import { fetchCurrentUser } from '../../ducks/user.duck';
import { addOrRemoveFavouriteGpt, fetchAllGpts, fetchAllGptsWithPage, fetchChatHistory, getFavouriteGpt } from '../../util/api';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';


export const REQUEST_SPACE_DETAILS = 'app/RuleBooksSearchPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/RuleBooksSearchPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/RuleBooksSearchPage/ERROR_SPACE_DETAILS';

export const REQUEST_FECTH_GPTS = 'app/RuleBooksSearchPage/REQUEST_FECTH_GPTS';
export const SUCCESS_FECTH_GPTS = 'app/RuleBooksSearchPage/SUCCESS_FECTH_GPTS';
export const ERROR_FECTH_GPTS = 'app/RuleBooksSearchPage/ERROR_FECTH_GPTS';

export const FETCH_CHAT_HISTORY_REQUEST = 'app/RuleBooksSearchPage/FETCH_CHAT_HISTORY_REQUEST';
export const FETCH_CHAT_HISTORY_SUCCESS = 'app/RuleBooksSearchPage/FETCH_CHAT_HISTORY_SUCCESS';
export const FETCH_CHAT_HISTORY_ERROR = 'app/RuleBooksSearchPage/FETCH_CHAT_HISTORY_ERROR';

export const FETCH_FAV_CHAT_SUCCESS = 'app/RuleBooksSearchPage/FETCH_FAV_CHAT_SUCCESS';
export const UPDATE_FAV_GPT_SUCCESS = 'app/RuleBooksSearchPage/UPDATE_FAV_GPT_SUCCESS';

const initialState = {
    requestSpaceDetails: false,
    spaceDetailsData: null,
    errorSpaceDetails: null,

    fetchAllGptsInProgress: false,
    gptsDetails: null,
    fetchAllGptsError: null,

    fetchChatInProgress: false,
    chatDetails: null,
    fetchChatError: null,

    userFavChatDetails: null,
    updateFavGpt: null,
};

export default function ruleBooksSearchPageReducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case REQUEST_SPACE_DETAILS:
            return { ...state, requestSpaceDetails: true };
        case SUCCESS_SPACE_DETAILS:
            return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
        case ERROR_SPACE_DETAILS:
            return {
                ...state,
                requestSpaceDetails: false,
                spaceDetailsData: null,
                errorSpaceDetails: payload.error,
            };

        case REQUEST_FECTH_GPTS:
            return { ...state, fetchAllGptsInProgress: true, gptsDetails: null };

        case SUCCESS_FECTH_GPTS:
            return { ...state, gptsDetails: payload, fetchAllGptsInProgress: false };
        case ERROR_FECTH_GPTS:
            return {
                ...state,
                fetchAllGptsInProgress: false,
                gptsDetails: null,
                fetchChatError: payload.error,
            };

        case FETCH_CHAT_HISTORY_REQUEST:
            return { ...state, fetchChatInProgress: true, };
        case FETCH_CHAT_HISTORY_SUCCESS:
            return { ...state, fetchChatInProgress: false, chatDetails: payload };
        case FETCH_CHAT_HISTORY_ERROR:
            return {
                ...state,
                fetchChatInProgress: false,
                chatDetails: null,
                fetchChatError: payload.error,
            };

        case FETCH_FAV_CHAT_SUCCESS:
            return { ...state, fetchChatInProgress: false, userFavChatDetails: payload };

        case UPDATE_FAV_GPT_SUCCESS:
            return { ...state, updateFavGpt: payload };


        default:
            return state;
    }
}

export const requestSpaceDetails = () => ({
    type: REQUEST_SPACE_DETAILS,
});
export const successSpaceDetails = data => ({
    type: SUCCESS_SPACE_DETAILS,
    payload: { data },
});
export const errorSpaceDetails = error => ({
    type: ERROR_SPACE_DETAILS,
    payload: { error },
});

export const requestFetchGpts = () => ({
    type: REQUEST_FECTH_GPTS,
});

export const successFetchGpts = data => ({
    type: SUCCESS_FECTH_GPTS,
    payload: data,
});

export const errorFetchGpts = error => ({
    type: ERROR_FECTH_GPTS,
    payload: { error },
});

export const fetchChatRequest = () => ({
    type: FETCH_CHAT_HISTORY_REQUEST,
});
export const fetchChatSuccess = data => ({
    type: FETCH_CHAT_HISTORY_SUCCESS,
    payload: data,
});
export const fetchChatError = error => ({
    type: FETCH_CHAT_HISTORY_ERROR,
    payload: { error },
});


export const fetchFavChatSuccess = data => ({
    type: FETCH_FAV_CHAT_SUCCESS,
    payload: data,
});

export const updateFavGptSuccess = data => ({
    type: UPDATE_FAV_GPT_SUCCESS,
    payload: data,
});

export const addOrRemoveFavChats = (params) => (dispatch, getState, sdk) => {
    const { rulebook_id, user_id } = params || {};
    dispatch(fetchChatRequest());
    return addOrRemoveFavouriteGpt({ rulebook_id, user_id }).then((res) => {
        dispatch(getFavouriteChats());
        return res;
    }).catch(error => {
        dispatch(fetchChatError(storableError(error)))
    });
};

export const getFavouriteChats = (rulebook_name) => (dispatch, getState, sdk) => {
    dispatch(fetchChatRequest());

    const { uuid } = getState()?.user?.currentUser?.id || {};
    if (!uuid) return null;
    return fetchAllGpts({ rulebook_name })
        .then((response) => {
            return getFavouriteGpt({ user_id: uuid })
                .then((favGptResponse) => {
                    dispatch(fetchFavChatSuccess({
                        favGpt: favGptResponse.favGpt || [],
                        gpts: response.gpts || []
                    }));

                    return favGptResponse;
                })
                .catch((favGptError) => {
                    console.error("Error fetching favorite GPTs:", favGptError);
                    dispatch(fetchFavChatSuccess({
                        favGpt: [],
                        gpts: response.gpts || []
                    }));
                });
        })
        .catch((error) => {
            console.error("Error fetching chats:", error);
            dispatch(errorFetchGpts(storableError(error)));
        });
};

export const getChatHistories = () => (dispatch, getState, sdk) => {
    dispatch(fetchChatRequest());
    const { uuid } = getState()?.user?.currentUser?.id || {};
    if (!uuid) return null;
    return fetchChatHistory({ user_id: uuid }).then((res) => {
        dispatch(fetchChatSuccess(res.chatHistory));
        return res;
    }).catch(error => {
        dispatch(fetchChatError(storableError(error)));
    });
};

export const getAllGpts = (params) => (dispatch, getState, sdk) => {
    dispatch(requestFetchGpts());
    return fetchAllGptsWithPage({ ...params }).then((response) => {
        dispatch(successFetchGpts(response));
    }).catch(error => {
        console.log(error, "error")
        dispatch(errorFetchGpts(storableError(error)));
    })
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  return Promise.all([dispatch(fetchCurrentUser())])
    .then(() => {
      const currentUser = getState().user.currentUser;
      const userEmail = currentUser?.attributes?.email;
       Promise.all([
        dispatch(getAllGpts({ rulebook_name: queryParams.rulebook, page: queryParams.page || 1, pageSize: 6 , userEmail })),
        dispatch(getChatHistories()),
        dispatch(getFavouriteChats(queryParams.rulebook)),
      ]);
      return {};
    })
    .catch(e => {
      throw e;
    });
};


